import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Select, MenuItem, FormControl, FormControlLabel, RadioGroup, Radio, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import ButtonTheme from "../../ThemeButton/ThemeButton";
import { getGridStringOperators } from "@mui/x-data-grid";
import ConfModal from "../../Modal/ConfModal";
import MyTable from "../../Schedule/MyTable";
import ApiService from "../../../functions/apiService";
import { toast } from 'react-toastify';

export default function PTOData() {
    // const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [modalData, setModalData] = useState([]);
    let columns = [
        {
            field: 'Emp_Code', headerName: 'ID', flex: 1, minWidth: 120,
            filterOperators: getGridStringOperators().filter(
                (operator) => operator.value === "contains"
            ),
        },
        {
            field: 'email', headerName: 'Email', flex: 1, minWidth: 120,
            filterOperators: getGridStringOperators().filter(
                (operator) => operator.value === "contains"
            ),
        },
        {
            field: 'Name', headerName: 'Name', flex: 1, minWidth: 120,
            valueGetter: (params) => params.row.First_name + ' ' + params.row.Last_name,
            filterOperators: getGridStringOperators().filter(
                (operator) => operator.value === "contains"
            ),
        },

    ];
    const onSubmit = () => {
        setLoading(true);
        ApiService.post('/employeeImportPtoFromCsv', [])
            .then(({ data }) => {
                setLoading(false);
                console.log('data', data);
                setModalData(data)
                setOpen(true);
                toast.success("Success")
                // enqueueSnackbar('success', { variant: 'success' });
            }).catch(({ data }) => {
                setLoading(false);
                toast.error("Error")
                // enqueueSnackbar('Error', { variant: 'error' });
            });
    }
    let closeModal = () => {
        setOpen(false);
    }
    return <>
        <Typography fontWeight='700' fontSize="16px">PTO Data</Typography>


        <div className="col-12 mt-2">
            <ButtonTheme disabled={loading} onClick={onSubmit} color='primary'>Import PTO</ButtonTheme>
        </div>
        <ConfModal Title='Employees' open={open} closeModal={closeModal} >

            {modalData && modalData && modalData.length > 0 &&

                <div >
                    <MyTable
                        rows={modalData}
                        columns={columns}
                        useTopFilter={false}
                        checkboxSelection={false}
                        hideFooter={true}
                    />
                </div>
            }
        </ConfModal>
    </>
}
